import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './layout.css';

// Remove loading spinner when React loads
const loadingSpinner = document.querySelector('.loading-spinner');
if (loadingSpinner) {
  loadingSpinner.remove();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
